export default __webpack_public_path__ + "static/marimekko-1e0e9c0e25bb5f15129e73c9c39e4d31.png";